<div class="page-container">
	<div class="grid-container">
		<tlk-banner *ngIf="isSendToIDSMessageVisible$ | async" class="grid-item grid-item-full" [type]="'info'">
			<span tlkBannerBody>{{ 'OrderSection.StudyModelsAreAvailableForInvisalignMessage' | translate }}</span>
		</tlk-banner>
		<rx-intuitive-order class="grid-item grid-item-full"></rx-intuitive-order>
		<rx-intuitive-appliance-details
			*ngIf="isApplianceProcedureSectionVisible$ | async"
			class="grid-item grid-item-full"
		></rx-intuitive-appliance-details>
		<rx-intuitive-invisalign-details
			*ngIf="isInvisalignDetailsVisible$ | async"
			class="grid-item grid-item-full"
		></rx-intuitive-invisalign-details>
		<rx-intuitive-scan-surgical-guide
			*ngIf="isScanSurgicalGuideVisible$ | async"
			class="grid-item grid-item-full"
		></rx-intuitive-scan-surgical-guide>
		<rx-intuitive-denture-procedure
			*ngIf="isDentureDetailsVisible$ | async"
			class="grid-item grid-item-full"
		></rx-intuitive-denture-procedure>
		<rx-intuitive-teeth-diagram-base-container
			*ngIf="isToothDiagramVisible$ | async"
			class="grid-item grid-item-full"
		></rx-intuitive-teeth-diagram-base-container>
		<rx-intuitive-scan-options class="grid-item grid-item-full"></rx-intuitive-scan-options>
		<div
			class="grid-item grid-item-full attachments-notes-row"
			[class.attachments-notes-row--read-only-both-fill]="attachmentsNotesReadOnlyBothFillRow$ | async"
		>
			<rx-intuitive-attachments />
			<rx-intuitive-notes />
		</div>

		<!-- Additional Content Placeholder -->
		<ng-content></ng-content>
	</div>
</div>
